import React, { useState, useRef } from 'react';
import cn from 'classnames';
import { Button, TextInput, TextInputType } from '@design-system';
import { useTranslation } from 'react-i18next';
import { translations } from 'translations';

export interface GraphSignatureProps {
  className?: string;
  onSign: () => void;
  isLoading: boolean;
  primaryColor: string;
  isAutographDisabled: boolean;
}

export const GraphSignature: React.FC<GraphSignatureProps> = ({
  className,
  onSign,
  isLoading = false,
  primaryColor,
  isAutographDisabled,
}) => {
  const { t } = useTranslation();

  const handleSign = () => {
    if (onSign) onSign();
  };

  return (
    <div className={className}>
      <div className="mb-4 flex">
        <div className="ml-auto">
          <Button
            className="px-8"
            size="sm"
            onClick={() => handleSign()}
            isLoading={isLoading}
            isDisabled={isAutographDisabled}
            color={primaryColor}>
            {t(translations.COMMON.SIGN)}
          </Button>
        </div>
      </div>
    </div>
  );
};
